
	frappe.templates['booking_credit_dashboard'] = `<!-- @dokos: Espresso card with a label / bar / value grid (styles in scss/booking_credit_dashboard.scss) -->
<div class="booking-credit-dashboard dk-card">
	<div class="dk-card__body">
		{% if balance.length %}
		<span class="dk-muted">{{ __("Balance for {0} on {1}", [customer, frappe.datetime.global_date_format()]) }}</span>
		<div class="bcd-grid">
			{% for bal in balance %}
			<span class="bcd-label">{{ bal.booking_credit_type || __("Credits") }}</span>
			{{ erpnext.dokos.ui.progress.html({ value: total > 0 ? Math.abs(bal.balance) / total * 100 : 0, theme: bal.balance < 0 ? "red" : "blue", label: bal.booking_credit_type || __("Credits") }) }}
			{% if bal.balance == 0 %}
			<span class="bcd-value dk-muted">{{ __("Zero balance") }}</span>
			{% else %}
			<span class="bcd-value dk-num {{ bal.balance < 0 ? "dk-ink-red" : "" }}">{{ __("{0} {1}", [bal.balance, __("Credits")]) }}</span>
			{% endif %}
			{% endfor %}
		</div>
		{% else %}
		<span class="dk-muted">{{ __("Zero balance for {0} on {1}", [customer, frappe.datetime.global_date_format()]) }}</span>
		{% endif %}
	</div>
</div>
`;
